module.exports = __webpack_public_path__ + "img/ig.9d60aa0d.svg";